export default {
  computed: {
    inputError () {
      return this.getError(this.errors.application, this.inputName)
    },

    hasInputErrors () {
      return this.hasError(this.errors.application, this.inputName)
    }
  }
}
